import { useState } from 'react';
import { Button, Row, Form, Spinner } from 'react-bootstrap';

import { fetchDataAuthenticated } from '../../../utilities/HttpUtils'
import { useSites } from '../../../utilities/useSites';
import useAlert from '../../Alerts/useAlert';
import AdminTile from './AdminTile';

const SampleManagerApiPingCheck = () => {
    const { sites, loading } = useSites();
    const { setAlert } = useAlert();
    const [variant, setVariant] = useState();
    const [error, setError] = useState();
    const [site, setSite] = useState("");
    const [requestLoading, setRequestLoading] = useState(false);

    const _apiUrl = window.runtimeConfig.WEBSITE_BACKEND_URI;

    const getPing = () => {
        if (!site) {
            return;
        }
        setRequestLoading(true);

        fetchDataAuthenticated(_apiUrl + `api/diagnostic/smapi/ping?sitename=${site}`, "GET")
            .then(response => {
                if (response.ok) {
                    let pingResponse = `Succesfully pinged SM for ${site}`;
                    setAlert("success", "Succesful", pingResponse);
                    setError(null);
                } else {
                    response.json().then(error => {
                        setAlert("danger", error.title, error.detail);
                        setVariant("danger");
                        setError(error.detail);
                    })
                }
            })
            .finally(() => setRequestLoading(false));
    }

    function SMPingCheck() {

        if (requestLoading || loading) {
            return (<Spinner />);
        }

        return (
            <>
                <Row className="mt-1">
                    <Form>
                        <Form.Group>
                            <Form.Label><strong>Site</strong></Form.Label>
                            <Form.Select type="text" className="config-select" value={site} onChange={(e) => setSite(e.target.value)}>
                                <option value="" key={0} >Please Select...</option>
                                {sites.map((si) => <option value={si.siteName} key={si.siteName}>(ID: {si.siteId} CONN:{si.smapiConnection}) - Name: {si.siteName}</option>)}
                            </Form.Select>
                        </Form.Group>
                    </Form>
                </Row>
                <Button type="submit" className="ms-auto mt-1" onClick={getPing}>Get</Button>
                {error && <div className="mt-1 mb-2">{error}</div>}
            </>
        );
    }

    return (
        <AdminTile
            title={"SM Ping Check"}
            description={"Get Ping information from sample manager api"}
            variant={variant}>
            <SMPingCheck />
        </AdminTile>
    );
}

export default SampleManagerApiPingCheck;